import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';
var Svg = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.624 9.15H21V22.5H3V9.15h3.376V6.965C6.376 3.947 8.895 1.5 12 1.5c3.105 0 5.624 2.447 5.624 5.465V9.15ZM8.733 6.972v2.195l6.547-.011.006-2.206c0-1.872-1.353-3.35-3.277-3.35-1.924 0-3.276 1.5-3.276 3.372Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var Lock = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});
export { Lock };